var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { CULTURE_CURRENCY } from 'globalconfig';
import { NUMERIC_FIELD_TYPES } from '../constants';
import { getStepValue } from '../utils/getStepValue';
import { checkNullOrUndefined } from 'utils';
const suffix = {
    currency: CULTURE_CURRENCY,
    percentage: '%',
    decimal: '.00',
    number: '#'
};
export const BasicInput = forwardRef((_a, ref) => {
    var { type, isInvalid, label, value, decimalPlaces } = _a, rest = __rest(_a, ["type", "isInvalid", "label", "value", "decimalPlaces"]);
    const InputSuffix = useMemo(() => NUMERIC_FIELD_TYPES.includes(type) && (_jsx(InputGroup.Text, { children: suffix[type] })), [type]);
    const formattedValue = useMemo(() => checkNullOrUndefined(type === 'date' ? value === null || value === void 0 ? void 0 : value.split('T')[0] : value, ''), [value]);
    const isNumericType = NUMERIC_FIELD_TYPES.includes(type);
    return (_jsxs(_Fragment, { children: [_jsx(Form.Label, Object.assign({ htmlFor: rest.name }, { children: label })), _jsxs(InputGroup, { children: [_jsx(Form.Control, Object.assign({}, rest, { value: formattedValue, id: rest.name, type: isNumericType ? 'number' : type, isInvalid: isInvalid, step: isNumericType ? getStepValue(decimalPlaces) : '', ref: ref })), InputSuffix] })] }));
});
BasicInput.displayName = 'BasicInput';
